import update from 'immutability-helper';
import {
  API_PAYMENT_PACKS_FETCH,
  API_PAYMENT_PACKS_FETCH_SUCCESS,
  API_PAYMENT_PACKS_FETCH_ERROR,
} from '../actions/types';
import {createReducer} from '../utils';

const initialState = {
  isPaymentsPacksFetching: false,
};

const treasureReducer = createReducer(initialState, {
  [API_PAYMENT_PACKS_FETCH]: state => update(state, {
    isPaymentsPacksFetching: {$set: true},
  }),
  [API_PAYMENT_PACKS_FETCH_SUCCESS]: (state, payload) => {
    const {response: {requester, ...rest}} = payload;

    return update(state, {
      isPaymentsPacksFetching: {$set: false},
      data: {$set: rest},
    });
  },
  [API_PAYMENT_PACKS_FETCH_ERROR]: (state, payload) => {
    const {error} = payload;
    const result = error;

    return update(state, {
      isPaymentsPacksFetching: {$set: false},
      result: {$set: result},
    });
  },
});

export default treasureReducer;
